import styled, { css } from 'styled-components';
import { ctaStyles, disabled } from '../../styles/components.js';
import { Backdrop } from '../../styles/stories.js';
import { addsMask } from '../../utils/color-manipulation.js';
import { mapBackgroundToContentColor } from '../../utils/color-mapper.js';
import 'react';

const hover = (props) => css `
  background: ${addsMask({
    color: props.backgroundColor,
    isBackgroundColor: true,
    props,
})};
`;
const focus = (props) => css `
    box-shadow: 0 0 0 2px
        ${mapBackgroundToContentColor({
    backgroundColor: props.backgroundColor,
    theme: props.theme,
})},
      0 0 0 4px ${props.theme.colors.background[props.backgroundColor]};
    outline: transparent solid 2px;
  `;
const active = (props) => css `
  background: ${addsMask({
    color: props.backgroundColor,
    isBackgroundColor: true,
    lighten: true,
    props,
})};
`;
const backgroundlessHover = (props) => css `
  background: ${addsMask({
    backgroundless: true,
    color: props.theme.colors.maps.contentToBackground[props.color],
    isBackgroundColor: true,
    props,
})};
`;
const backgroundlessFocus = (props) => css `
    transition: none;
    box-shadow: 0 0 0 2px ${props.theme.colors.content[props.color]};
  `;
const backgroundlessActive = (props) => css `
  background: ${addsMask({
    backgroundless: true,
    color: props.theme.colors.maps.contentToBackground[props.color],
    isBackgroundColor: true,
    lighten: true,
    props,
})};
`;
const backgroundless = (props) => css `
  background: none;
  color: ${props.theme.colors.content[props.color]};
  border: 1px solid ${props.theme.colors.content[props.color]};

  &:hover {
    ${backgroundlessHover}
  }

  &:focus {
    ${backgroundlessFocus}
  }

  &:active {
    ${backgroundlessActive}
  }
`;
const StyledButton = styled.button `
  background: ${props => props.theme.colors.background[props.backgroundColor]};
  border: 1px solid
    ${props => props.theme.colors.background[props.backgroundColor]};
  color: ${props => mapBackgroundToContentColor({
    backgroundColor: props.backgroundColor,
    theme: props.theme,
})};
  ${ctaStyles}

  &:hover {
    ${hover}
  }

  &:focus {
    ${focus}
  }

  &:active {
    ${active}
  }

  &:disabled {
    ${disabled}
  }

  ${props => props.backgroundless && backgroundless}
`;
styled(Backdrop).attrs({ height: 125 }) `
  & > * {
    margin: 0;
  }

  & > :first-child {
    margin-top: 8px;
  }

  & > :last-child {
    margin-top: 16px;
  }
`;

export { StyledButton };
